import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  green: {
    color: theme.palette.success.main
  },
  base: {
    fontSize: "0.8rem",
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  red: {
    color: theme.palette.error.main
  },
  yellow: {
    color: theme.palette.warning.main
  },
  gray: {
    color: theme.palette.grey[600]
  }
}));

export function TradelineFurnishmentStatusLabel({ status }) {
  const classes = useStyles();
  return (
    <span
      className={clsx(classes.base, {
        [classes.green]: status === "active",
        [classes.gray]: status === "inactive"
      })}
    >
      {status}
    </span>
  );
}
